export default "__VITE_ASSET__CFKSrY_2__"